import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import axios from 'axios';

// Layout
import Base from '@/layouts/Base.vue';

// Auth
import Auth from '@/views/Auth.vue';
import Logout from '@/views/Logout.vue';
import ResetPassword from '@/views/ResetPassword.vue';

// Root
import Events from '@/views/Events.vue';
import Actions from '@/views/Actions.vue';
import Settings from '@/views/Settings.vue';
import Dashboard from '@/views/Dashboard.vue';
import PublicInfList from '@/views/PublicInfList.vue';

// In-Settings
import Fnds from '@/views/settings/Fnds.vue';
import Users from '@/views/settings/Users.vue';
import Roles from '@/views/settings/Roles.vue';
import Skills from '@/views/settings/Skills.vue';
import Sponsors from '@/views/settings/Sponsors.vue';
import EventRoles from '@/views/settings/EventRoles.vue';
import EventTypes from '@/views/settings/EventTypes.vue';
import Organizations from '@/views/settings/Organizations.vue';
import ControlPointRequests from '@/views/settings/ControlPointRequests.vue';

// Event
import Event from '@/views/event/Event.vue';
import AddInfo from '@/views/event/AddInfo.vue';
import EventUsers from '@/views/event/Users.vue';
import Diplomas from '@/views/event/Diplomas.vue';
import Packages from '@/views/event/Packages.vue';
import BaseInfo from '@/views/event/BaseInfo.vue';
import EventSkills from '@/views/event/Skills.vue';
import EventProjects from '@/views/event/Projects.vue';
import EventTransfers from '@/views/event/Transfers.vue';
import EventEmployees from '@/views/event/Employees.vue';
import EventKnowledgeBase from '@/views/event/KnowledgeBase.vue';

// Skill
import Info from '@/views/skill/Info.vue';
import Skill from '@/views/skill/Skill.vue';
import InfList from '@/views/skill/InfList.vue';
import MainExpert from '@/views/skill/MainExpert.vue';
import TechExpert from '@/views/skill/TechExpert.vue';
import Participants from '@/views/skill/Participants.vue';

// Package
import Package from '@/views/package/Package.vue';
import PackageInfo from '@/views/package/Info.vue';
import PackageUnits from '@/views/package/Units.vue';
import PackageQuotas from '@/views/package/Quotas.vue';

// Project
import Project from '@/views/project/Project.vue';
import ProjectInfo from '@/views/project/Info.vue';
import ControlPoints from '@/views/project/ControlPoints.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: Base,
    redirect: { name: 'auth' },
    meta: { requiresAuth: true },
    children: [{
      path: '/auth',
      name: 'auth',
      component: Auth,
      meta: { requiresAuth: false },
    }, {
      path: '/reset_password/',
      name: 'reset_password_start',
      component: ResetPassword,
      meta: { requiresAuth: false },
    }, {
      path: '/reset_password/:token',
      name: 'reset_password_continue',
      component: ResetPassword,
      meta: { requiresAuth: false },
    }, {
      path: '/dashboard/control_points',
      name: 'dashboard_control_points',
      component: Dashboard,
    }, {
      path: '/dashboard/projects',
      name: 'dashboard_projects',
      component: Dashboard,
    }, {
      path: '/actions',
      name: 'actions',
      component: Actions,
    }, {
      path: '/events/:page',
      name: 'events',
      component: Events,
    }, {
      path: '/skills/:page',
      name: 'skills',
      component: Skills,
    }, {
      path: '/settings',
      name: 'settings',
      component: Settings,
    }, {
      path: '/users/:page',
      name: 'users',
      component: Users,
    }, {
      path: '/roles/:page',
      name: 'roles',
      component: Roles,
    }, {
      path: '/event_roles/:page',
      name: 'event_roles',
      component: EventRoles,
    }, {
      path: '/fnd/:page',
      name: 'fnds',
      component: Fnds,
    }, {
      path: '/event_types/:page',
      name: 'event_types',
      component: EventTypes,
    }, {
      path: '/organizations/:page',
      name: 'organizations',
      component: Organizations,
    }, {
      path: '/sponsors/:page',
      name: 'sponsors',
      component: Sponsors,
    }, {
      path: '/control_point_requests/:page',
      name: 'control_point_requests',
      component: ControlPointRequests,
    }, {
      path: '/inf_list/:code',
      name: 'public_inf_list',
      component: PublicInfList,
      meta: { requiresAuth: false },
    }, {
      path: '/event/:eventID',
      name: 'event',
      component: Event,
      redirect: { name: 'base_info' },
      children: [{
        path: 'event_skills',
        name: 'event_skills',
        component: EventSkills,
      }, {
        path: 'add_info',
        name: 'add_info',
        component: AddInfo,
      }, {
        path: 'base_info',
        name: 'base_info',
        component: BaseInfo,
      }, {
        path: 'diplomas',
        name: 'diplomas',
        component: Diplomas,
      }, {
        path: 'users',
        name: 'event_users',
        component: EventUsers,
      }, {
        path: 'event_employees/:page',
        name: 'event_employees',
        component: EventEmployees,
      }, {
        path: 'projects/:page',
        name: 'event_projects',
        component: EventProjects,
      }, {
        path: 'knowledge_base',
        name: 'event_knowledge_base',
        component: EventKnowledgeBase,
      }, {
        path: 'transfers/:page',
        name: 'event_transfers',
        component: EventTransfers,
        meta: { requiresAuth: false },
      }, {
        path: 'packages/:page',
        name: 'packages',
        component: Packages,
      }],
    }, {
      path: '/event/:eventID/skill/:skillID',
      name: 'skill',
      component: Skill,
      redirect: { name: 'info' },
      children: [{
        path: 'info',
        name: 'info',
        component: Info,
      }, {
        path: 'participants',
        name: 'participants',
        component: Participants,
      }, {
        path: 'main_expert',
        name: 'main_expert',
        component: MainExpert,
      }, {
        path: 'tech_expert',
        name: 'tech_expert',
        component: TechExpert,
      }, {
        path: 'inf_list',
        name: 'inf_list',
        component: InfList,
      }],
    }, {
      path: '/event/:eventID/package/:packageID',
      name: 'package',
      component: Package,
      redirect: { name: 'package_info' },
      children: [{
        path: 'info',
        name: 'package_info',
        component: PackageInfo,
      }, {
        path: 'quotas/:page',
        name: 'package_quotas',
        component: PackageQuotas,
      }, {
        path: 'units',
        name: 'package_units',
        component: PackageUnits,
      }],
    }, {
      path: '/project/:projectID',
      name: 'project',
      component: Project,
      redirect: { name: 'project_info' },
      children: [{
        path: 'info',
        name: 'project_info',
        component: ProjectInfo,
      }, {
        path: 'control_points/board',
        name: 'project_control_points_board',
        component: ControlPoints,
      }, {
        path: 'control_points/list/:page',
        name: 'project_control_points_list',
        component: ControlPoints,
      }],
    }],
  }, {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: { requiresAuth: false },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth !== false) {
    if (!store.getters['session/isAuthenticated']) {
      window.location.replace(`/logout`);
    }
    if (store.getters['session/isTokenExpired']) {
      await axios({
        baseURL: process.env.VUE_APP_API_ENDPOINT,
        url: '/v1/auth/refresh',
        method: 'POST'
      })
        .then(response => response.data)
        .then(({ error, auth: tokenInfo }) => {
          if (error) {
            window.location.replace(`/logout`)
          }
          if (tokenInfo.access_token) {
            store.dispatch('session/setToken', tokenInfo.access_token)
            store.dispatch('session/setExpiryTokenDate', tokenInfo.ttl)
          }
        })
        .catch(() => {
          window.location.replace(`/logout`)
        });
    }
    store.dispatch('session/getProfile');
  }
  next();
})

export default router;
